import type { CompensationRule } from '@/services/compensation/types';

export const payslipKeys = {
  all: ['payslips'] as const,
  lists: () => [...payslipKeys.all, 'list'] as const,
  list: (profileId: string) => [...payslipKeys.lists(), profileId] as const,
  details: () => [...payslipKeys.all, 'detail'] as const,
  detail: (id: string) => [...payslipKeys.details(), id] as const,
  lineItems: (payslipId: string) => [...payslipKeys.all, 'lineItems', payslipId] as const,
  breakdown: (payslipId: string) => [...payslipKeys.all, 'breakdown', payslipId] as const,
  validation: (companyId: string, changes: CompensationRule[]) => [
    ...payslipKeys.all, 
    'validation', 
    companyId, 
    changes.map(c => c.id).sort()
  ] as const,
  payslipValidation: (profileId: string, startDate: string, endDate: string) => [
    ...payslipKeys.all,
    'payslipValidation',
    profileId,
    startDate,
    endDate
  ] as const,
} as const;
